var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 11.2497V16.6663H15V11.2497C15 9.16634 13.3333 7.49967 11.25 7.49967H6.52498L9.09165 10.0747L7.91665 11.2497L3.33331 6.66634L7.91665 2.08301L9.09998 3.25801L6.52498 5.83301H11.25C12.6866 5.83301 14.0643 6.40369 15.0801 7.41951C16.096 8.43533 16.6666 9.81308 16.6666 11.2497Z",
    fill: "#19171B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiArrow);
export default __webpack_public_path__ + "static/media/mdi-arrow.4e47458af1735dfb01f7074386a91dba.svg";
export { ForwardRef as ReactComponent };